<template>
  <div class="privacy-policy-banner" v-if="showBanner && bannerContent">
    <div class="Pp-container">
      <div class="statement-container" v-html="decode(bannerContent)"></div>
      <button class="close-btn" @click="onDismiss"><i class="fas fa-times fa-2x"></i></button>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import config from "../../../config/constants";

export default {
  name: "PrivacyPolicyBanner",
  props: {
    statement: String,
  },
  data() {
    return {
      showBanner: true,
	    bannerContent: null
    };
  },
	async mounted() {
		this.getBanner()
	},
  methods: {
		decode(str){
			return atob(str)
		},
    onDismiss() {
      this.showBanner = false;
    },
	  async getBanner() {
		  const payload = {
			  user_id: this.$store.getters.user_id,
		  }
		  const res = await axios.post(config.api_env + '/application/api/u/user/get-privacy-banner', payload, config.options)
		  if (res.data.success && res.data.banner_copy) {
			  this.bannerContent = res.data.banner_copy
		  } else if (res.data.err && res.data.err.includes("3994")) {
			  this.$store.dispatch("logout");
		  }
	  },
  },
};
</script>

<style lang="less">
.privacy-policy-banner {
	a {
		color: white !important;
    text-decoration: underline;
	}
  width: 100%;
  padding: 19px 20px;

  .Pp-container {
    display: flex;
    width: 100%;
    max-width: 1980px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }
  
  .statement-container {
    padding-right: 20px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    
    .privacy {
      color: #FFFFFF;
      text-decoration: underline;
    }
  }
  
  .close-btn {
    background-color: transparent;
    border: 0;
    color: #fff;
  }
}
</style>
